import logoIcon from '../../assets/logo-icon.png'

const SIZES = {
  sm: 28,
  md: 40,
  lg: 64,
}

export default function Logo({ variant = 'full', size = 'md' }) {
  const px = SIZES[size]

  return (
    <img
      src={logoIcon}
      alt="Debnix"
      height={px}
      style={{ height: px, width: 'auto', display: 'block', objectFit: 'contain' }}
    />
  )
}